import {
  BillingNoteHeaderType,
  CombinePaymentNoteHeaderType,
  CreditNoteExpenseHeaderType,
  CreditNoteHeaderType,
  CurrencyCode,
  DebitNoteExpenseHeaderType,
  DebitNoteHeaderType,
  DepositExpenseHeaderType,
  DepositHeaderType,
  DocumentType,
  DocumentUpdatePassCodeType,
  ExpenseHeaderType,
  FinanceType,
  GoodsReceiptHeaderType,
  InvoiceHeaderType,
  InvoiceReceiptHeaderType,
  LoadingStatusType,
  PeakExceptionResponseCode,
  PurchaseOrderHeaderType,
  PurchaseRequisitionHeaderType,
  QuotationHeaderType,
  ReceiptHeaderType,
  TaxInvoiceHeaderType,
  TransactionType,
  TypeComponentNoti,
} from "@/enums/enums";
import {
  CheckIsNotToSaveFromMainSetting,
  ConvertToSettingContactEnvelopeTemplate,
  ConvertToSettingDocumentTemplate,
  ConvertToSettingExecutiveSummaryTemplate,
  ConvertToSettingJournalDocumentTemplate,
  ConvertToSettingPndDocumentTemplate,
  ConvertToSettingPP30xDocumentTemplate,
  ConvertToSettingWithholdingTaxDocumentTemplate,
  GetDefaultSettingTemplateModel,
  SetValueForContactAndMerchantInfo,
} from "@/helper/documentHelper";
import {
  GetAppConnectMessageExceptionCode,
  GetMessageExceptionCode,
  NewObjectWithInstance,
} from "@/helper/shareHelper";
import { i18n } from "@/i18n";
import {
  ContactEnvelopeDocumentTemplateModel,
  ContactEnvelopeOnlineViewModel,
} from "@/model/document/contactEnvelopeModel";
import {
  DocumentSaveSettingModel,
  DocumentSaveSettingOptionModel,
  DocumentTemplateHeaderTypeModel,
  DocumentTemplateModel,
  DocumentUpdateOnlineViewPassCodeModel,
  DocumentWithPassCodeModel,
  InputDoSetSetttingDefaultModel,
  OnlineViewCustomizeModel,
  OnlineViewModel,
} from "@/model/document/documentModel";
import {
  ExecutiveSummaryDocumentTemplateModel,
  ExecutiveSummaryOnlineViewModel,
} from "@/model/document/executiveSummaryModel";
import { JournalDocumentTemplateModel, JournalOnlineViewModel } from "@/model/document/journalDocumentModal";
import { PndDocumentTemplateModel, PndOnlineViewModel } from "@/model/document/pndDocumentModel";
import { PP30DocumentTemplateModel, PP30OnlineViewModel } from "@/model/document/pp30DocumentModel";
import {
  SettingContactEnvelopeDocumentTemplateModel,
  SettingDocumentTemplateModel,
  SettingExecutiveSummaryDocumentTemplateModel,
  SettingJournalDocumentTemplateModel,
  SettingPndDocumentTemplateModel,
  SettingPP30DocumentTemplateModel,
  SettingWitholdingTaxDocumentTemplateModel,
} from "@/model/document/settingDocumentTemplate";
import {
  WithholdingTaxDocumentTemplateModel,
  WitholdingTaxOnlineViewModel,
} from "@/model/document/witholdingTaxDocumentModal";
import router from "@/router";
import { ConvertToBillingNoteOnlineView } from "@/service/document/BillingNote/billingNoteFacade";
import { ConvertToCombinePaymentNoteOnlineView } from "@/service/document/combinePaymentNote/combinePaymentNoteFacade";
import { ConvertToContactEnvelopeOnlineView } from "@/service/document/contact/contactFacade";
import { ConvertToCreditNoteOnlineView } from "@/service/document/CreditNote/creditNoteFacade";
import { ConvertToCreditNoteExpenseOnlineView } from "@/service/document/CreditNoteExpense/creditNoteExpenseFacade";
import { ConvertToCustomizeIdList, ConvertToCustomizeOnlineView } from "@/service/document/customize/customizeFacade";
import { ConvertToDailyJournalOnlineView } from "@/service/document/dailyJournal/dailyJournalFacade";
import { ConvertToDebitNoteOnlineView } from "@/service/document/debitNote/debitNoteFacade";
import { ConvertToDebitNoteExpenseOnlineView } from "@/service/document/DebitNoteExpense/debitNoteExpenseFacade";
import {
  ConvertToDepositExpenseOnlineView,
  ConvertToDepositOnlineView,
} from "@/service/document/deposit/depositFacade";
import { ConvertToExecutiveSummaryOnlineView } from "@/service/document/executiveSummary/executiveSummaryFacade";
import { ConvertToExpenseOnlineView } from "@/service/document/expense/expenseFacade";
import { ConvertToGoodsReceiptOnlineView } from "@/service/document/goodsReceipt/goodsReceiptFacade";
import { ConvertToInvoiceOnlineView } from "@/service/document/invoice/invoiceFacade";
import { ConvertToInvoiceReceiptOnlineView } from "@/service/document/invoiceReceipt/invoiceReceiptFacade";
import { ConvertToPndOnlineView } from "@/service/document/pnd/pndFacade";
import { ConvertToPP30OnlineView } from "@/service/document/pp30/pp30Facade";
import { ConvertToPurchaseOrderOnlineView } from "@/service/document/purchaseOrder/purchaseOrderFacade";
import { ConvertToPurchaseRequisitionOnlineView } from "@/service/document/purchaseRequisition/purchaseRequisitionFacade";
import { ConvertToQuotationOnlineView } from "@/service/document/quotation/quatationFacade";
import { ConvertToReceiptOnlineView } from "@/service/document/receipt/receiptFacade";
import { ConvertToTaxInvoiceOnlineView } from "@/service/document/taxInvoice/taxInvoiceFacade";
import { ConvertToWitholdingTaxOnlineView } from "@/service/document/witholdingTax/WitholdingTaxFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Document extends VuexModule {
  private documentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private documentDetail: OnlineViewModel | JournalOnlineViewModel | OnlineViewCustomizeModel | null = null;
  private updateDocumentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private isEditMode = false;
  private documentCreateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private setDefaultDocument = false;
  private isSaveSettingOption: DocumentSaveSettingOptionModel | null = null;
  private saveSettingLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private removeOnlineViewPassCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private updateOnlineViewPassCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private passCode: string = "";
  private updateOnlineViewPassCodePrintPdfLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private documentName: string = "";
  private settingTemplateDefaultLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private settingTemplateDefault:
    | SettingDocumentTemplateModel
    | SettingJournalDocumentTemplateModel
    | SettingWitholdingTaxDocumentTemplateModel
    | SettingPndDocumentTemplateModel
    | SettingPP30DocumentTemplateModel
    | SettingContactEnvelopeDocumentTemplateModel
    | null = null;
  private switchCurrency: CurrencyCode = CurrencyCode.THB;
  private isCanSwitchCurrency = false;
  private customizeIdList: Array<any> | null = null;
  private customizeIdListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private validateRequestTaxInvoiceLinkLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private validateRequestTaxInvoiceReceiptLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactForRequestTaxInvoiceLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private requestTaxInvoiceContactData: any = null;
  private requestTaxInvoiceDocumentData: any = null;
  private submitRequestTaxInvoiceLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private submitRequestTaxInvoiceData: any = null;

  get getSubmitRequestTaxInvoiceData(): any {
    return this.submitRequestTaxInvoiceData;
  }
  get getSubmitRequestTaxInvoiceLoadingStatus(): LoadingStatusType {
    return this.submitRequestTaxInvoiceLoadingStatus;
  }
  get getRequestTaxInvoiceDocumentData(): any {
    return this.requestTaxInvoiceDocumentData;
  }
  get getRequestTaxInvoiceContactData(): any {
    return this.requestTaxInvoiceContactData;
  }
  get getContactForRequestTaxInvoiceLoadingStatus(): LoadingStatusType {
    return this.contactForRequestTaxInvoiceLoadingStatus;
  }
  get getValidateRequestTaxInvoiceReceiptLoadingStatus(): LoadingStatusType {
    return this.validateRequestTaxInvoiceReceiptLoadingStatus;
  }
  get getValidateRequestTaxInvoiceLinkLoadingStatus(): LoadingStatusType {
    return this.validateRequestTaxInvoiceLinkLoadingStatus;
  }
  get getDocumentCreateLoadingStatus(): LoadingStatusType {
    return this.documentCreateLoadingStatus;
  }
  get getDocumentLoadingStatus(): LoadingStatusType {
    return this.documentLoadingStatus;
  }
  get getDocumentDetail():
    | OnlineViewModel
    | JournalOnlineViewModel
    | PP30OnlineViewModel
    | PndOnlineViewModel
    | OnlineViewCustomizeModel
    | null {
    return this.documentDetail;
  }
  get getUpdateDocumentLoadingStatus(): LoadingStatusType {
    return this.updateDocumentLoadingStatus;
  }
  get getIsEditMode(): boolean {
    return this.isEditMode;
  }
  get getSetDefaultDocument(): boolean {
    return this.setDefaultDocument;
  }
  get getIsSaveSettingOption(): DocumentSaveSettingOptionModel | null {
    return this.isSaveSettingOption;
  }
  get getSaveSettingLoadingStatus(): LoadingStatusType {
    return this.saveSettingLoadingStatus;
  }
  get getRemoveOnlineViewPassCodeLoadingStatus(): LoadingStatusType {
    return this.removeOnlineViewPassCodeLoadingStatus;
  }
  get getUpdateOnlineViewPassCodeLoadingStatus(): LoadingStatusType {
    return this.updateOnlineViewPassCodeLoadingStatus;
  }
  get getDocumentPassCode(): string {
    return this.passCode;
  }
  get getUpdateOnlineViewPassCodePrintPdfLoadingStatus(): LoadingStatusType {
    return this.updateOnlineViewPassCodePrintPdfLoadingStatus;
  }
  get getDocumentName(): string {
    return this.documentName;
  }
  get getSettingTemplateDefaultLoadingStatus(): LoadingStatusType {
    return this.settingTemplateDefaultLoadingStatus;
  }
  get getSettingTemplateDefault():
    | SettingDocumentTemplateModel
    | SettingJournalDocumentTemplateModel
    | SettingWitholdingTaxDocumentTemplateModel
    | SettingPndDocumentTemplateModel
    | SettingPP30DocumentTemplateModel
    | SettingContactEnvelopeDocumentTemplateModel
    | null {
    return this.settingTemplateDefault;
  }
  get getSwitchCurrency(): CurrencyCode {
    return this.switchCurrency;
  }
  get getIsCanSwitchCurrency(): boolean {
    return this.isCanSwitchCurrency;
  }
  get getCustomizeIdList(): Array<any> | null {
    return this.customizeIdList;
  }
  get getCustomizeIdListLoadingStatus(): LoadingStatusType {
    return this.customizeIdListLoadingStatus;
  }

  @Mutation
  public MutationDocumentCreateLoadingStatus(status: LoadingStatusType) {
    this.documentCreateLoadingStatus = status;
  }
  @Mutation
  public MutationSetIsEditMode(isEditMode: boolean) {
    this.isEditMode = isEditMode;
  }
  @Mutation
  public MutationSetDefaultDocument(setDefaultDocument: boolean) {
    this.setDefaultDocument = setDefaultDocument;
  }
  @Mutation
  public MutationSetIsSaveSettingOption(isSaveSettingOption: DocumentSaveSettingOptionModel) {
    this.isSaveSettingOption = isSaveSettingOption;
  }
  @Mutation
  public MutationDocumentLoadingStatus(status: LoadingStatusType) {
    this.documentLoadingStatus = status;
  }
  @Mutation
  public MutationDocumentDetail(documentDetail: OnlineViewModel) {
    this.documentDetail = documentDetail;
  }
  @Mutation MutationUpdateDocumentLoadingStatus(status: LoadingStatusType) {
    this.updateDocumentLoadingStatus = status;
  }
  @Mutation
  public MutationRemoveOnlineViewPassCodeLoadingStatus(status: LoadingStatusType) {
    this.removeOnlineViewPassCodeLoadingStatus = status;
  }
  @Mutation
  public MutationUpdateOnlineViewPassCodeLoadingStatus(status: LoadingStatusType) {
    this.updateOnlineViewPassCodeLoadingStatus = status;
  }
  @Mutation
  public MutationSaveSettingLoadingStatus(loadingStatus: LoadingStatusType) {
    this.saveSettingLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationSetPassCode(passCode: string = "") {
    this.passCode = passCode;
  }
  @Mutation
  public MutationUpdateOnlineViewPassCodePrintPdfLoadingStatus(status: LoadingStatusType) {
    this.updateOnlineViewPassCodePrintPdfLoadingStatus = status;
  }
  @Mutation
  public SetDocumentName(documentName: string) {
    this.documentName = documentName;
  }
  @Mutation
  public MutationSettingTemplateDefaultLoadingStatus(status: LoadingStatusType) {
    this.settingTemplateDefaultLoadingStatus = status;
  }
  @Mutation
  public MutationSettingTemplateDefault(
    settingTemplate:
      | SettingDocumentTemplateModel
      | SettingJournalDocumentTemplateModel
      | SettingWitholdingTaxDocumentTemplateModel
      | SettingPndDocumentTemplateModel
      | SettingPP30DocumentTemplateModel
      | SettingContactEnvelopeDocumentTemplateModel
      | null
  ) {
    this.settingTemplateDefault = settingTemplate;
  }
  @Mutation
  public SetSwitchCurrency(currency: CurrencyCode) {
    this.switchCurrency = currency;
  }
  @Mutation
  public SetIsCanSwitchCurrency(isCanSwitchCurrency: boolean) {
    this.isCanSwitchCurrency = isCanSwitchCurrency;
  }
  @Mutation
  public SetCustomizeIdList(customizeIdList: Array<any>) {
    this.customizeIdList = customizeIdList;
  }
  @Mutation
  public SetCustomizeIdListLoadingStatus(status: LoadingStatusType) {
    this.customizeIdListLoadingStatus = status;
  }

  @Mutation
  public SetRequestTaxInvoiceContactData(requestTaxInvoiceContactData: any) {
    this.requestTaxInvoiceContactData = requestTaxInvoiceContactData;
  }

  @Mutation
  public SetSubmitRequestTaxInvoiceData(submitRequestTaxInvoiceData: any) {
    this.submitRequestTaxInvoiceData = submitRequestTaxInvoiceData;
  }

  @Mutation
  public SetSubmitRequestTaxInvoiceLoadingStatus(status: LoadingStatusType) {
    this.submitRequestTaxInvoiceLoadingStatus = status;
  }

  @Mutation
  public SetContactForRequestTaxInvoiceLoadingStatus(status: LoadingStatusType) {
    this.contactForRequestTaxInvoiceLoadingStatus = status;
  }

  @Mutation
  public SetRequestTaxInvoiceDocumentData(requestTaxInvoiceDocumentData: any) {
    this.requestTaxInvoiceDocumentData = requestTaxInvoiceDocumentData;
  }

  @Mutation
  public SetValidateRequestTaxInvoiceReceiptLoadingStatus(status: LoadingStatusType) {
    this.validateRequestTaxInvoiceReceiptLoadingStatus = status;
  }

  @Mutation
  public SetValidateRequestTaxInvoiceLinkLoadingStatus(status: LoadingStatusType) {
    this.validateRequestTaxInvoiceLinkLoadingStatus = status;
  }

  @Action DoSetDocumentCreateLoadingStatus(status: LoadingStatusType) {
    this.context.commit("MutationDocumentCreateLoadingStatus", status);
  }

  @Action
  public DoSetIsEditMode(isEditMode: boolean) {
    this.context.commit("MutationSetIsEditMode", isEditMode);
  }

  @Action
  public DoSetDefaultDocument(setDefaultDocument: boolean) {
    this.context.commit("MutationSetDefaultDocument", setDefaultDocument);
  }

  @Action
  public DoSetIsSaveSettingOption(isSaveSettingOption: DocumentSaveSettingOptionModel) {
    this.context.commit("MutationSetIsSaveSettingOption", isSaveSettingOption);
  }

  @Action
  public DoGetSettingDefault(input: InputDoSetSetttingDefaultModel) {
    if (this.settingTemplateDefaultLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSettingTemplateDefaultLoadingStatus", LoadingStatusType.Loading);
      let settingTemplate:
        | SettingDocumentTemplateModel
        | SettingJournalDocumentTemplateModel
        | SettingWitholdingTaxDocumentTemplateModel
        | SettingPndDocumentTemplateModel
        | SettingPP30DocumentTemplateModel
        | SettingContactEnvelopeDocumentTemplateModel
        | SettingExecutiveSummaryDocumentTemplateModel
        | null = GetDefaultSettingTemplateModel(
        input.transactionType,
        input.financeType ?? 0,
        input.expenseType ?? 0,
        input.headerOptionType ?? 0,
        input.isTaxInvoice ?? false,
        input.toCurrency ?? CurrencyCode.THB
      );

      this.context.commit("MutationSettingTemplateDefault", settingTemplate);
      setTimeout(() => {
        this.context.commit("MutationSettingTemplateDefaultLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Your_Document_Was_Reset_To_Default"),
            typeMessage: TypeComponentNoti.Success,
          },
          { root: true }
        );
      }, 250);
    }
  }

  @Action
  public DoSaveSettingDocument(input: DocumentSaveSettingModel) {
    if (input.isSaveFromMainTemplate && CheckIsNotToSaveFromMainSetting(this.getDocumentDetail)) {
      return;
    }
    if (this.documentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSaveSettingLoadingStatus", LoadingStatusType.Loading);
      let settingDocumentTemplate!:
        | SettingDocumentTemplateModel
        | SettingJournalDocumentTemplateModel
        | SettingWitholdingTaxDocumentTemplateModel
        | SettingPP30DocumentTemplateModel
        | SettingPndDocumentTemplateModel
        | SettingContactEnvelopeDocumentTemplateModel
        | SettingExecutiveSummaryDocumentTemplateModel;
      let documentDetail!:
        | OnlineViewModel
        | JournalOnlineViewModel
        | WitholdingTaxOnlineViewModel
        | PP30OnlineViewModel
        | PndOnlineViewModel
        | ContactEnvelopeOnlineViewModel
        | ExecutiveSummaryOnlineViewModel;

      if (input.documentTemplate.transactionType === TransactionType.DailyJournal) {
        settingDocumentTemplate = ConvertToSettingJournalDocumentTemplate(
          input.documentTemplate as JournalDocumentTemplateModel,
          false
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (input.documentTemplate.transactionType === TransactionType.WithholdingTax) {
        settingDocumentTemplate = ConvertToSettingWithholdingTaxDocumentTemplate(
          input.documentTemplate as WithholdingTaxDocumentTemplateModel,
          false
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (input.documentTemplate.transactionType === TransactionType.PP30) {
        settingDocumentTemplate = ConvertToSettingPP30xDocumentTemplate(
          input.documentTemplate as PP30DocumentTemplateModel,
          false
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (
        input.documentTemplate.transactionType === TransactionType.Pnd1 ||
        input.documentTemplate.transactionType === TransactionType.Pnd2 ||
        input.documentTemplate.transactionType === TransactionType.Pnd3 ||
        input.documentTemplate.transactionType === TransactionType.Pnd53
      ) {
        settingDocumentTemplate = ConvertToSettingPndDocumentTemplate(
          input.documentTemplate as PndDocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (input.documentTemplate.transactionType === DocumentType.Envelope) {
        settingDocumentTemplate = ConvertToSettingContactEnvelopeTemplate(
          input.documentTemplate as ContactEnvelopeDocumentTemplateModel,
          false
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (input.documentTemplate.transactionType === DocumentType.ExecutiveSummary) {
        settingDocumentTemplate = ConvertToSettingExecutiveSummaryTemplate(
          input.documentTemplate as ExecutiveSummaryDocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else {
        settingDocumentTemplate = ConvertToSettingDocumentTemplate(
          input.documentTemplate as DocumentTemplateModel,
          false
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      }
      settingDocumentTemplate = SetValueForContactAndMerchantInfo(settingDocumentTemplate, this.getDocumentDetail);
      this.context.commit("MutationDocumentDetail", documentDetail);
      API.DocumentService.DoUpdateTemplateDetailDocument(
        settingDocumentTemplate,
        input.documentId,
        input.headerType
      ).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          if (!input.isSaveFromMainTemplate) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Alert_Save_Document_Success", {
                  name: this.documentName,
                  number: input.documentNumber,
                }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
          }
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception.exceptionCode);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSaveSettingLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoSaveSettingMainDocument(input: DocumentSaveSettingModel) {
    if (this.documentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSaveSettingLoadingStatus", LoadingStatusType.Loading);
      let settingDocumentTemplate!:
        | SettingDocumentTemplateModel
        | SettingJournalDocumentTemplateModel
        | SettingWitholdingTaxDocumentTemplateModel
        | SettingPP30DocumentTemplateModel
        | SettingPndDocumentTemplateModel
        | SettingContactEnvelopeDocumentTemplateModel
        | SettingExecutiveSummaryDocumentTemplateModel;
      let documentDetail!:
        | OnlineViewModel
        | JournalOnlineViewModel
        | WitholdingTaxOnlineViewModel
        | PP30OnlineViewModel
        | PndOnlineViewModel
        | ContactEnvelopeOnlineViewModel
        | ExecutiveSummaryOnlineViewModel;

      if (input.documentTemplate.transactionType === TransactionType.DailyJournal) {
        settingDocumentTemplate = ConvertToSettingJournalDocumentTemplate(
          input.documentTemplate as JournalDocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (input.documentTemplate.transactionType === TransactionType.WithholdingTax) {
        settingDocumentTemplate = ConvertToSettingWithholdingTaxDocumentTemplate(
          input.documentTemplate as WithholdingTaxDocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (input.documentTemplate.transactionType === TransactionType.PP30) {
        settingDocumentTemplate = ConvertToSettingPP30xDocumentTemplate(
          input.documentTemplate as PP30DocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (
        input.documentTemplate.transactionType === TransactionType.Pnd1 ||
        input.documentTemplate.transactionType === TransactionType.Pnd2 ||
        input.documentTemplate.transactionType === TransactionType.Pnd3 ||
        input.documentTemplate.transactionType === TransactionType.Pnd53
      ) {
        settingDocumentTemplate = ConvertToSettingPndDocumentTemplate(
          input.documentTemplate as PndDocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (input.documentTemplate.transactionType === DocumentType.Envelope) {
        settingDocumentTemplate = ConvertToSettingContactEnvelopeTemplate(
          input.documentTemplate as ContactEnvelopeDocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else if (input.documentTemplate.transactionType === DocumentType.ExecutiveSummary) {
        settingDocumentTemplate = ConvertToSettingExecutiveSummaryTemplate(
          input.documentTemplate as ExecutiveSummaryDocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      } else {
        settingDocumentTemplate = ConvertToSettingDocumentTemplate(
          input.documentTemplate as DocumentTemplateModel,
          true
        );

        documentDetail = NewObjectWithInstance(this.documentDetail);
        documentDetail.template = settingDocumentTemplate;
      }

      this.context.commit("MutationDocumentDetail", documentDetail);
      API.DocumentService.DoUpdateTemplateMainDetailDocument(
        settingDocumentTemplate,
        input.documentId,
        input.headerType
      ).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Alert_Save_Document_Success", {
                name: this.documentName,
                number: input.documentNumber,
              }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception.exceptionCode);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSaveSettingLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoSaveSettingMainExecutiveSummaryDocument(input: DocumentSaveSettingModel) {
    if (this.documentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSaveSettingLoadingStatus", LoadingStatusType.Loading);
      let settingDocumentTemplate!: SettingExecutiveSummaryDocumentTemplateModel;
      let documentDetail!: ExecutiveSummaryOnlineViewModel;

      settingDocumentTemplate = ConvertToSettingExecutiveSummaryTemplate(
        input.documentTemplate as ExecutiveSummaryDocumentTemplateModel,
        true
      );

      documentDetail = NewObjectWithInstance(this.documentDetail);
      documentDetail.template = settingDocumentTemplate;

      this.context.commit("MutationDocumentDetail", documentDetail);
      API.DocumentService.DoUpdateTemplateMainExecutiveSummaryDocument(
        settingDocumentTemplate,
        input.documentId,
        input.headerType
      ).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Alert_Save_Document_Success", {
                name: this.documentName,
                number: input.documentNumber,
              }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSaveSettingLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoGetDocumentWithPassCode(input: DocumentWithPassCodeModel) {
    if (this.documentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Loading);
      switch (input.transactionType) {
        case TransactionType.Quotation: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "QO": {
                input.headerType = QuotationHeaderType.MainQuotationHeader;
                break;
              }
              case "CUS": {
                input.headerType = QuotationHeaderType.CustomizeHeader;
                break;
              }
              case "TDN": {
                input.headerType = QuotationHeaderType.TemporaryDeliveryNoteHeader;
                break;
              }
              default: {
                input.headerType = QuotationHeaderType.MainQuotationHeader;
              }
            }
            API.QuotationService.DoGetQuotationDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToQuotationOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "PO": {
                input.headerType = PurchaseOrderHeaderType.MainPurchaseOrderHeader;
                break;
              }
              case "CUS": {
                input.headerType = PurchaseOrderHeaderType.CustomizeHeader;
                break;
              }
              case "PCR": {
                input.headerType = PurchaseOrderHeaderType.PurchaseRequisitionHeader;
                break;
              }
              case "PMR": {
                input.headerType = PurchaseOrderHeaderType.PaymentRequisitionHeader;
                break;
              }
              default: {
                input.headerType = PurchaseOrderHeaderType.MainPurchaseOrderHeader;
              }
            }
            API.PurchaseOrderService.DoGetPurchaseOrderDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToPurchaseOrderOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Invoice: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "IV": {
                input.headerType = InvoiceHeaderType.MainInvoiceHeader;
                break;
              }
              case "CUS": {
                input.headerType = InvoiceHeaderType.CustomizeHeader;
                break;
              }
              case "IVDN": {
                input.headerType = InvoiceHeaderType.DeliveryNoteHeader;
                break;
              }
              case "IVBN": {
                input.headerType = InvoiceHeaderType.BillingNoteHeader;
                break;
              }
              case "BOG": {
                input.headerType = InvoiceHeaderType.BillOfGoodsHeader;
                break;
              }
              default: {
                input.headerType = InvoiceHeaderType.MainInvoiceHeader;
              }
            }
            API.InvoiceService.DoGetInvoiceDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToInvoiceOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "EXP": {
                input.headerType = ExpenseHeaderType.MainExpenseHeader;
                break;
              }
              case "CUS": {
                input.headerType = ExpenseHeaderType.CustomizeHeader;
                break;
              }
              case "EPN": {
                input.headerType = ExpenseHeaderType.PaymentNoteHeader;
                break;
              }
              case "ECN": {
                input.headerType = ExpenseHeaderType.ClaimNoteHeader;
                break;
              }
              case "BOL": {
                input.headerType = ExpenseHeaderType.BillOfLadingHeader;
                break;
              }
              default: {
                input.headerType = ExpenseHeaderType.MainExpenseHeader;
              }
            }
            API.ExpenseService.DoGetExpenseDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToExpenseOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Receipt: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "RT": {
                input.headerType = ReceiptHeaderType.MainReceiptHeader;
                break;
              }
              case "CUS": {
                input.headerType = ReceiptHeaderType.CustomizeHeader;
                break;
              }
              case "RN": {
                input.headerType = ReceiptHeaderType.ReceiveNoteHeader;
                break;
              }
              case "CRT": {
                input.headerType = ReceiptHeaderType.CashReceiptHeader;
                break;
              }
              case "ABB": {
                input.headerType = ReceiptHeaderType.AbbA4Header;
                break;
              }
              case "POS58": {
                input.headerType = ReceiptHeaderType.AbbPos58Header;
                break;
              }
              default: {
                input.headerType = ReceiptHeaderType.MainReceiptHeader;
              }
            }
            API.ReceiptService.DoGetReceiptDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToReceiptOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Deposit: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "CUS": {
                input.headerType = DepositHeaderType.CustomizeHeader;
                break;
              }
              case "DR": {
                input.headerType = DepositHeaderType.DepositAndReceiptHeader;
                break;
              }
              case "RD": {
                input.headerType = DepositHeaderType.ReceiptHeader;
                break;
              }
              default:
                input.headerType = DepositHeaderType.MainDepositHeader;
            }
            API.DepositService.DoGetDepositDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToDepositOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "CUS": {
                input.headerType = DepositExpenseHeaderType.CustomizeHeader;
                break;
              }
              case "DE": {
                input.headerType = DepositExpenseHeaderType.DepositExpenseReceiptHeader;
                break;
              }
              case "ED": {
                input.headerType = DepositExpenseHeaderType.ExpenseDepositHeader;
                break;
              }
              case "EPN": {
                input.headerType = DepositExpenseHeaderType.PaymentNoteHeader;
                break;
              }
              default:
                input.headerType = DepositExpenseHeaderType.MainDepositExpenseHeader;
            }
            API.DepositService.DoGetDepositExpenseDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToDepositExpenseOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.GoodsReceipt: {
          if (input.financeType == FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "GR": {
                input.headerType = GoodsReceiptHeaderType.MainGoodsReceiptHeader;
                break;
              }
              case "CUS": {
                input.headerType = GoodsReceiptHeaderType.CustomizeHeader;
                break;
              }
            }
            API.GoodsReceiptsService.DoGetGoodsReceiptDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToGoodsReceiptOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.InvoiceReceipt: {
          if (input.financeType == FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "IR": {
                input.headerType = InvoiceReceiptHeaderType.MainInvoiceReceiptHeader;
                break;
              }
              case "CUS": {
                input.headerType = InvoiceReceiptHeaderType.CustomizeHeader;
                break;
              }
              default: {
                input.headerType = InvoiceReceiptHeaderType.MainInvoiceReceiptHeader;
              }
            }
            API.InvoiceReceiptService.DoGetInvoiceReceiptDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToInvoiceReceiptOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.TaxInvoice: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "TIV": {
                input.headerType = TaxInvoiceHeaderType.MainTaxInvoiceHeader;
                break;
              }
              case "CUS": {
                input.headerType = TaxInvoiceHeaderType.CustomizeHeader;
                break;
              }
              default: {
                input.headerType = TaxInvoiceHeaderType.MainTaxInvoiceHeader;
              }
            }
            API.TaxInvoiceService.DoGetTaxInvoiceDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToTaxInvoiceOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.DailyJournal: {
          API.DailyJournalService.DoGetJournalDocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToDailyJournalOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", input.passCode);
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Wrong_Passcode"),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
            } else {
              router.push("/404");
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });

          break;
        }
        case TransactionType.BillingNote: {
          if (input.financeType === FinanceType.InFlow) {
            API.BillingNoteService.DoGetBillingNoteDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToBillingNoteOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else {
            API.CombinePaymentNoteService.DoGetCombinePaymentNoteDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToCombinePaymentNoteOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }

          break;
        }
        case TransactionType.WithholdingTax: {
          API.WitholdingTaxService.DoGetWitholdingTaxDocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToWitholdingTaxOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", input.passCode);
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Wrong_Passcode"),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
            } else {
              router.push("/404");
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });

          break;
        }
        case TransactionType.PP30: {
          API.PP30Service.DoGetPP30DocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPP30OnlineView(res.data.data, input.financeType);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", input.passCode);
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Wrong_Passcode"),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
            } else {
              router.push("/404");
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });

          break;
        }
        case TransactionType.Pnd1: {
          API.PndService.DoGetPnd1DocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPndOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", input.passCode);
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Wrong_Passcode"),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
            } else {
              router.push("/404");
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });

          break;
        }
        case TransactionType.Pnd2: {
          API.PndService.DoGetPnd2DocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPndOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", input.passCode);
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Wrong_Passcode"),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
            } else {
              router.push("/404");
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });

          break;
        }
        case TransactionType.Pnd3: {
          API.PndService.DoGetPnd3DocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPndOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", input.passCode);
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Wrong_Passcode"),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
            } else {
              router.push("/404");
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });

          break;
        }
        case TransactionType.Pnd53: {
          API.PndService.DoGetPnd53DocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPndOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", input.passCode);
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Wrong_Passcode"),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
            } else {
              router.push("/404");
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });

          break;
        }
        case TransactionType.CreditNote: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "TIV": {
                input.headerType = CreditNoteHeaderType.MainCreditNoteHeader;
                break;
              }
              case "CUS": {
                input.headerType = CreditNoteHeaderType.CustomizeHeader;
                break;
              }
              default: {
                input.headerType = CreditNoteHeaderType.MainCreditNoteHeader;
              }
            }
            API.CreditNoteService.DoGetCreditNotDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToCreditNoteOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "BN": {
                input.headerType = CreditNoteExpenseHeaderType.MainCreditNoteExpenseHeader;
                break;
              }
              case "CUS": {
                input.headerType = CreditNoteExpenseHeaderType.CustomizeHeader;
                break;
              }
              case "EPN": {
                input.headerType = CreditNoteExpenseHeaderType.PaymentNoteHeader;
                break;
              }
              default: {
                input.headerType = CreditNoteExpenseHeaderType.MainCreditNoteExpenseHeader;
              }
            }
            API.CreditNoteExpenseService.DoGetCreditNotExpenseDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToCreditNoteExpenseOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.DebitNote: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "TIV": {
                input.headerType = DebitNoteHeaderType.MainDebitNoteHeader;
                break;
              }
              case "CUS": {
                input.headerType = DebitNoteHeaderType.CustomizeHeader;
                break;
              }
              default: {
                input.headerType = DebitNoteHeaderType.MainDebitNoteHeader;
              }
            }
            API.DebitNoteService.DoGetDebitNoteDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToDebitNoteOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "BN": {
                input.headerType = DebitNoteExpenseHeaderType.MainDebitNoteExpenseHeader;
                break;
              }
              case "CUS": {
                input.headerType = DebitNoteExpenseHeaderType.CustomizeHeader;
                break;
              }
              default: {
                input.headerType = DebitNoteExpenseHeaderType.MainDebitNoteExpenseHeader;
              }
            }
            API.DebitNoteExpenseService.DoGetDebitNoteExpenseDocumentPublicLink(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToDebitNoteExpenseOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", input.passCode);
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Wrong_Passcode"),
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
              } else {
                router.push("/404");
                this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              }
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.PurchaseRequisition: {
          switch (input.headerTypeCode) {
            case "CUS": {
              input.headerType = PurchaseRequisitionHeaderType.CustomizeHeader;
              break;
            }
            default: {
              input.headerType = PurchaseRequisitionHeaderType.MainPurchaseRequisitionHeader;
            }
          }
          API.PurchaseRequisitionService.DoGetPurchaseRequisitionDocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPurchaseRequisitionOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", input.passCode);
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Wrong_Passcode"),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
            } else {
              router.push("/404");
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case DocumentType.Envelope: {
          API.ContactService.DoGetContactEnvelopeDocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToContactEnvelopeOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case DocumentType.ExecutiveSummary: {
          API.ExecutiveSummaryService.DoGetExecutiveSummaryDocumentPublicLink(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToExecutiveSummaryOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
      }
    }
  }
  @Action
  public DoGetCustomizeDocumentPublicLink(input: any) {
    if (this.documentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Loading);
      API.CustomizeService.DoGetCustomizeDocumentPublicLink(input).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          const documentDetail = ConvertToCustomizeOnlineView(res.data.data);
          this.context.commit("MutationDocumentDetail", documentDetail);
          this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
        } else if (res.data.exception.exceptionCode === PeakExceptionResponseCode.InvalidDocumentPassCode) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Wrong_Passcode"),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Fail);
        } else {
          router.push("/404");
          this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetDocument(input: DocumentTemplateHeaderTypeModel) {
    if (this.documentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Loading);
      switch (input.transactionType) {
        case TransactionType.Quotation: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "QO": {
                input.headerType = QuotationHeaderType.MainQuotationHeader;
                break;
              }
              case "CUS": {
                input.headerType = QuotationHeaderType.CustomizeHeader;
                break;
              }
              case "TDN": {
                input.headerType = QuotationHeaderType.TemporaryDeliveryNoteHeader;
                break;
              }
              default: {
                input.headerType = QuotationHeaderType.MainQuotationHeader;
              }
            }
            API.QuotationService.DoGetQuotationDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToQuotationOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "PO": {
                input.headerType = PurchaseOrderHeaderType.MainPurchaseOrderHeader;
                break;
              }
              case "CUS": {
                input.headerType = PurchaseOrderHeaderType.CustomizeHeader;
                break;
              }
              case "PCR": {
                input.headerType = PurchaseOrderHeaderType.PurchaseRequisitionHeader;
                break;
              }
              case "PMR": {
                input.headerType = PurchaseOrderHeaderType.PaymentRequisitionHeader;
                break;
              }
              default: {
                input.headerType = PurchaseOrderHeaderType.MainPurchaseOrderHeader;
              }
            }
            API.PurchaseOrderService.DoGetPurchaseOrderDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToPurchaseOrderOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Invoice: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "IV": {
                input.headerType = InvoiceHeaderType.MainInvoiceHeader;
                break;
              }
              case "CUS": {
                input.headerType = InvoiceHeaderType.CustomizeHeader;
                break;
              }
              case "IVDN": {
                input.headerType = InvoiceHeaderType.DeliveryNoteHeader;
                break;
              }
              case "IVBN": {
                input.headerType = InvoiceHeaderType.BillingNoteHeader;
                break;
              }
              case "BOG": {
                input.headerType = InvoiceHeaderType.BillOfGoodsHeader;
                break;
              }
              default: {
                input.headerType = InvoiceHeaderType.MainInvoiceHeader;
              }
            }
            API.InvoiceService.DoGetInvoiceDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToInvoiceOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "EXP": {
                input.headerType = ExpenseHeaderType.MainExpenseHeader;
                break;
              }
              case "CUS": {
                input.headerType = ExpenseHeaderType.CustomizeHeader;
                break;
              }
              case "EPN": {
                input.headerType = ExpenseHeaderType.PaymentNoteHeader;
                break;
              }
              case "ECN": {
                input.headerType = ExpenseHeaderType.ClaimNoteHeader;
                break;
              }
              case "BOL": {
                input.headerType = ExpenseHeaderType.BillOfLadingHeader;
                break;
              }
              default: {
                input.headerType = ExpenseHeaderType.MainExpenseHeader;
              }
            }
            API.ExpenseService.DoGetExpenseDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToExpenseOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Receipt: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "RT": {
                input.headerType = ReceiptHeaderType.MainReceiptHeader;
                break;
              }
              case "CUS": {
                input.headerType = ReceiptHeaderType.CustomizeHeader;
                break;
              }
              case "RN": {
                input.headerType = ReceiptHeaderType.ReceiveNoteHeader;
                break;
              }
              case "CRT": {
                input.headerType = ReceiptHeaderType.CashReceiptHeader;
                break;
              }
              case "ABB": {
                input.headerType = ReceiptHeaderType.AbbA4Header;
                break;
              }
              case "POS58": {
                input.headerType = ReceiptHeaderType.AbbPos58Header;
                break;
              }
              default: {
                input.headerType = ReceiptHeaderType.MainReceiptHeader;
              }
            }
            API.ReceiptService.DoGetReceiptDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToReceiptOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Deposit: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "CUS": {
                input.headerType = DepositHeaderType.CustomizeHeader;
                break;
              }
              case "DR": {
                input.headerType = DepositHeaderType.DepositAndReceiptHeader;
                break;
              }
              case "RD": {
                input.headerType = DepositHeaderType.ReceiptHeader;
                break;
              }
              default:
                input.headerType = DepositHeaderType.MainDepositHeader;
            }
            API.DepositService.DoGetDepositDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToDepositOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "CUS": {
                input.headerType = DepositExpenseHeaderType.CustomizeHeader;
                break;
              }
              case "DE": {
                input.headerType = DepositExpenseHeaderType.DepositExpenseReceiptHeader;
                break;
              }
              case "ED": {
                input.headerType = DepositExpenseHeaderType.ExpenseDepositHeader;
                break;
              }
              case "EPN": {
                input.headerType = DepositExpenseHeaderType.PaymentNoteHeader;
                break;
              }
              default:
                input.headerType = DepositExpenseHeaderType.MainDepositExpenseHeader;
            }
            API.DepositService.DoGetDepositExpenseDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToDepositExpenseOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }

          break;
        }
        case TransactionType.GoodsReceipt: {
          if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "GR": {
                input.headerType = GoodsReceiptHeaderType.MainGoodsReceiptHeader;
                break;
              }
              case "CUS": {
                input.headerType = GoodsReceiptHeaderType.CustomizeHeader;
                break;
              }
            }
            API.GoodsReceiptsService.DoGetGoodsReceiptDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToGoodsReceiptOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.InvoiceReceipt: {
          switch (input.headerTypeCode) {
            case "IR": {
              input.headerType = GoodsReceiptHeaderType.MainGoodsReceiptHeader;
              break;
            }
            case "CUS": {
              input.headerType = GoodsReceiptHeaderType.CustomizeHeader;
              break;
            }
            default: {
              input.headerType = GoodsReceiptHeaderType.MainGoodsReceiptHeader;
            }
          }
          API.InvoiceReceiptService.DoGetInvoiceReceiptDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToInvoiceReceiptOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.TaxInvoice: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "TIV": {
                input.headerType = TaxInvoiceHeaderType.MainTaxInvoiceHeader;
                break;
              }
              case "CUS": {
                input.headerType = TaxInvoiceHeaderType.CustomizeHeader;
                break;
              }
              default: {
                input.headerType = TaxInvoiceHeaderType.MainTaxInvoiceHeader;
              }
            }
            API.TaxInvoiceService.DoGetTaxInvoiceDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToTaxInvoiceOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.DailyJournal: {
          API.DailyJournalService.DoGetJournalDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToDailyJournalOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.BillingNote: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "BN": {
                input.headerType = BillingNoteHeaderType.MainBillingNoteHeader;
                break;
              }
              case "CUS": {
                input.headerType = BillingNoteHeaderType.CustomizeHeader;
                break;
              }
              default: {
                input.headerType = BillingNoteHeaderType.MainBillingNoteHeader;
              }
            }
            API.BillingNoteService.DoGetBillingNoteDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const data = { ...res.data.data };
                const documentDetail = ConvertToBillingNoteOnlineView(data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else {
            switch (input.headerTypeCode) {
              case "BN": {
                input.headerType = CombinePaymentNoteHeaderType.MainCombinePaymentNoteNoteHeader;
                break;
              }
              case "CUS": {
                input.headerType = CombinePaymentNoteHeaderType.CustomizeHeader;
                break;
              }
              case "EPN": {
                input.headerType = CombinePaymentNoteHeaderType.PaymentNoteHeader;
                break;
              }
              default: {
                input.headerType = CombinePaymentNoteHeaderType.MainCombinePaymentNoteNoteHeader;
              }
            }
            API.CombinePaymentNoteService.DoGetCombinePaymentNoteDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToCombinePaymentNoteOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }

          break;
        }
        case TransactionType.WithholdingTax: {
          API.WitholdingTaxService.DoGetWitholdingTaxDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToWitholdingTaxOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.PP30: {
          API.PP30Service.DoGetPP30Document(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPP30OnlineView(res.data.data, input.financeType);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.Pnd1: {
          API.PndService.DoGetPnd1Document(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPndOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.Pnd2: {
          API.PndService.DoGetPnd2Document(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPndOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.Pnd3: {
          API.PndService.DoGetPnd3Document(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPndOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.Pnd53: {
          API.PndService.DoGetPnd53Document(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPndOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.CreditNote: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "TIV": {
                input.headerType = CreditNoteHeaderType.MainCreditNoteHeader;
                break;
              }
              case "CUS": {
                input.headerType = CreditNoteHeaderType.CustomizeHeader;
                break;
              }

              default: {
                input.headerType = CreditNoteHeaderType.MainCreditNoteHeader;
              }
            }
            API.CreditNoteService.DoGetCreditNoteDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToCreditNoteOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "BN": {
                input.headerType = CreditNoteExpenseHeaderType.MainCreditNoteExpenseHeader;
                break;
              }
              case "CUS": {
                input.headerType = CreditNoteExpenseHeaderType.CustomizeHeader;
                break;
              }
              case "EPN": {
                input.headerType = CreditNoteExpenseHeaderType.PaymentNoteHeader;
                break;
              }
              default: {
                input.headerType = CreditNoteExpenseHeaderType.MainCreditNoteExpenseHeader;
              }
            }
            API.CreditNoteExpenseService.DoGetCreditNoteExpenseDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToCreditNoteExpenseOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.DebitNote: {
          if (input.financeType === FinanceType.InFlow) {
            switch (input.headerTypeCode) {
              case "TIV": {
                input.headerType = DebitNoteHeaderType.MainDebitNoteHeader;
                break;
              }
              case "CUS": {
                input.headerType = DebitNoteHeaderType.CustomizeHeader;
                break;
              }

              default: {
                input.headerType = DebitNoteHeaderType.MainDebitNoteHeader;
              }
            }
            API.DebitNoteService.DoGetDebitNoteDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToDebitNoteOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            switch (input.headerTypeCode) {
              case "BN": {
                input.headerType = DebitNoteExpenseHeaderType.MainDebitNoteExpenseHeader;
                break;
              }
              case "CUS": {
                input.headerType = DebitNoteExpenseHeaderType.CustomizeHeader;
                break;
              }
              default: {
                input.headerType = DebitNoteExpenseHeaderType.MainDebitNoteExpenseHeader;
              }
            }
            API.DebitNoteExpenseService.DoGetDebitNoteExpenseDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                const documentDetail = ConvertToDebitNoteExpenseOnlineView(res.data.data);
                this.context.commit("MutationDocumentDetail", documentDetail);
                this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
              } else {
                router.push("/404");
              }
              this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.PurchaseRequisition: {
          switch (input.headerTypeCode) {
            case "CUS": {
              input.headerType = PurchaseRequisitionHeaderType.CustomizeHeader;
              break;
            }
            default: {
              input.headerType = PurchaseRequisitionHeaderType.MainPurchaseRequisitionHeader;
            }
          }
          API.PurchaseRequisitionService.DoGetPurchaseRequisitionDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToPurchaseRequisitionOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
              this.context.commit("MutationSetPassCode", documentDetail.credential.passCode);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });

          break;
        }
        case DocumentType.Envelope: {
          API.ContactService.DoGetContactEnvelopeDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToContactEnvelopeOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case DocumentType.ExecutiveSummary: {
          API.ExecutiveSummaryService.DoGetExecutiveSummaryDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              const documentDetail = ConvertToExecutiveSummaryOnlineView(res.data.data);
              this.context.commit("MutationDocumentDetail", documentDetail);
            } else {
              router.push("/404");
            }
            this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
      }
    }
  }
  @Action
  public DoGetCustomizeDocument(input: any) {
    if (this.documentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Loading);
      API.CustomizeService.DoGetCustomizeDocument(input).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          const documentDetail = ConvertToCustomizeOnlineView(res.data.data);
          this.context.commit("MutationDocumentDetail", documentDetail);
        } else {
          router.push("/404");
        }
        this.context.commit("MutationDocumentLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoUpdateDocumentDetail(input: any) {
    if (this.updateDocumentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      switch (input.transactionType) {
        case TransactionType.Quotation: {
          if (input.financeType === FinanceType.InFlow) {
            API.QuotationService.DoUpdateQuotationDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            API.PurchaseOrderService.DoUpdatePurchaseOrderDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Invoice: {
          if (input.financeType === FinanceType.InFlow) {
            API.InvoiceService.DoUpdateInvoiceDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            API.ExpenseService.DoUpdateExpenseDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Receipt: {
          if (input.financeType === FinanceType.InFlow) {
            API.ReceiptService.DoUpdateReceiptDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.Deposit: {
          if (input.financeType === FinanceType.InFlow) {
            API.DepositService.DoUpdateDepositDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            API.DepositService.DoUpdateDepositExpenseDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.GoodsReceipt: {
          if (input.financeType === FinanceType.OutFlow) {
            API.GoodsReceiptsService.DoUpdateGoodsReceiptDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.InvoiceReceipt: {
          if (input.financeType === FinanceType.OutFlow) {
            API.InvoiceReceiptService.DoUpdateInvoiceReceiptDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.TaxInvoice: {
          if (input.financeType === FinanceType.InFlow) {
            API.TaxInvoiceService.DoUpdateTaxInvoiceDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.DailyJournal: {
          API.DailyJournalService.DoUpdateJournalDetailDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Alert_Update_Document_Success", {
                    name: input.documentName,
                    number: input.transactionNumber,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.BillingNote: {
          if (input.financeType === FinanceType.InFlow) {
            API.BillingNoteService.DoUpdateBillingNoteDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else {
            API.CombinePaymentNoteService.DoUpdateCombinePaymentNoteDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }

          break;
        }
        case TransactionType.WithholdingTax: {
          API.WitholdingTaxService.DoUpdateWitholdingTaxDetailDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Alert_Update_Document_Success", {
                    name: input.documentName,
                    number: input.transactionNumber,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.PP30: {
          API.PP30Service.DoUpdatePP30DetailDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Alert_Update_Document_Success", {
                    name: " " + input.documentName,
                    number: input.transactionNumber,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.Pnd1: {
          API.PndService.DoUpdatePnd1DetailDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Alert_Update_Document_Success", {
                    name: " " + input.documentName,
                    number: input.transactionNumber,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.Pnd2: {
          API.PndService.DoUpdatePnd2DetailDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Alert_Update_Document_Success", {
                    name: " " + input.documentName,
                    number: input.transactionNumber,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.Pnd3: {
          API.PndService.DoUpdatePnd3DetailDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Alert_Update_Document_Success", {
                    name: " " + input.documentName,
                    number: input.transactionNumber,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.Pnd53: {
          API.PndService.DoUpdatePnd53DetailDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Alert_Update_Document_Success", {
                    name: " " + input.documentName,
                    number: input.transactionNumber,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
        case TransactionType.CreditNote: {
          if (input.financeType === FinanceType.InFlow) {
            API.CreditNoteService.DoUpdatecreditNoteDetailDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: " " + input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            API.CreditNoteExpenseService.DoUpdateCreditNoteExpenseDetail(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: " " + input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.DebitNote: {
          if (input.financeType === FinanceType.InFlow) {
            API.DebitNoteService.DoUpdateDebitNoteDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: " " + input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          } else if (input.financeType === FinanceType.OutFlow) {
            API.DebitNoteExpenseService.DoUpdateDebitNoteExpenseDocument(input).then((res: any) => {
              if (res.data.responseCode.IsSuccess()) {
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: i18n.t("Alert_Update_Document_Success", {
                      name: " " + input.documentName,
                      number: input.transactionNumber,
                    }),
                    typeMessage: TypeComponentNoti.Success,
                  },
                  { root: true }
                );
              } else {
                const alertMessage = GetMessageExceptionCode(res.data.exception);
                this.context.dispatch(
                  "Alert/SetAlertMessage",
                  {
                    alertMessage: alertMessage,
                    typeMessage: TypeComponentNoti.Error,
                  },
                  { root: true }
                );
              }
              this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
          break;
        }
        case TransactionType.PurchaseRequisition: {
          API.PurchaseRequisitionService.DoUpdatePurchaseRequisitionDocument(input).then((res: any) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Alert_Update_Document_Success", {
                    name: " " + input.documentName,
                    number: input.transactionNumber,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("MutationUpdateDocumentLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          });
          break;
        }
      }
    }
  }
  @Action
  public DoRemoveOnlineViewPassCode(input: DocumentUpdateOnlineViewPassCodeModel) {
    if (this.removeOnlineViewPassCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationRemoveOnlineViewPassCodeLoadingStatus", LoadingStatusType.Loading);
      API.DocumentService.DoRemoveOnlineViewPassCode(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Alert_Remove_Passcode_Success", {
                name: (input.isDocumentNameShort ? " " : "") + input.documentName,
                number: input.transactionNumber,
              }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationRemoveOnlineViewPassCodeLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoUpdateOnlineViewPassCode(input: DocumentUpdateOnlineViewPassCodeModel) {
    if (this.updateOnlineViewPassCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationUpdateOnlineViewPassCodeLoadingStatus", LoadingStatusType.Loading);
      let alertMessageSuccess: any = "";
      switch (input.documentUpdatePassCodeType) {
        case DocumentUpdatePassCodeType.Create:
          alertMessageSuccess = i18n.t("Alert_Create_Passcode_Success", {
            name: (input.isDocumentNameShort ? " " : "") + input.documentName,
            number: input.transactionNumber,
          });
          break;
        case DocumentUpdatePassCodeType.Update:
          alertMessageSuccess = i18n.t("Alert_Reset_Passcode_Success", {
            name: (input.isDocumentNameShort ? " " : "") + input.documentName,
            number: input.transactionNumber,
          });
          break;
        case DocumentUpdatePassCodeType.CopyLink:
          alertMessageSuccess = i18n.t("Alert_Copy_Link_Success", {
            name: (input.isDocumentNameShort ? " " : "") + input.documentName,
            number: input.transactionNumber,
          });
          break;
      }
      API.DocumentService.DoUpdateOnlineViewPassCode(input).then((res: any) => {
        if (res.status.IsSuccess() && res.data.data) {
          this.context.commit("MutationSetPassCode", res.data.data);
          if (input.documentUpdatePassCodeType === DocumentUpdatePassCodeType.PrintPdf) {
            this.context.commit("MutationUpdateOnlineViewPassCodePrintPdfLoadingStatus", LoadingStatusType.Success);
          } else {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessageSuccess,
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
          }
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationUpdateOnlineViewPassCodeLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoSetUpdateOnlineViewPassCodePrintPdfLoadingStatus(status: LoadingStatusType) {
    this.context.commit("MutationUpdateOnlineViewPassCodePrintPdfLoadingStatus", status);
  }
  @Action
  public DoGetCustomizeIdList(input: any) {
    if (this.customizeIdListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCustomizeIdListLoadingStatus", LoadingStatusType.Loading);
      API.CustomizeService.DoGetCustomizeIdList(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          const customizeIdList = ConvertToCustomizeIdList(
            res.data.data,
            input.transactionType,
            input.financeType,
            input.expenseType
          );
          this.context.commit("SetCustomizeIdList", customizeIdList);
        }
        this.context.commit("SetCustomizeIdListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoValidateRequestTaxInvoiceLink(input: any) {
    if (this.validateRequestTaxInvoiceLinkLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetValidateRequestTaxInvoiceLinkLoadingStatus", LoadingStatusType.Loading);
      API.CustomizeService.DoValidateRequestTaxInvoiceLink(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          if (res.data.responseCode.IsSuccess()) {
            this.context.commit("SetValidateRequestTaxInvoiceLinkLoadingStatus", LoadingStatusType.Success);
          } else {
            this.context.commit("SetValidateRequestTaxInvoiceLinkLoadingStatus", LoadingStatusType.Fail);
          }
        } else {
          this.context.commit("SetValidateRequestTaxInvoiceLinkLoadingStatus", LoadingStatusType.Fail);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoValidateRequestTaxInvoiceReceipt(input: any) {
    if (this.validateRequestTaxInvoiceReceiptLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetValidateRequestTaxInvoiceReceiptLoadingStatus", LoadingStatusType.Loading);
      API.CustomizeService.DoValidateRequestTaxInvoiceReceipt(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          if (res.data.responseCode.IsSuccess()) {
            this.context.commit("SetRequestTaxInvoiceDocumentData", res.data.data);
            this.context.commit("SetValidateRequestTaxInvoiceReceiptLoadingStatus", LoadingStatusType.Success);
          } else {
            const alertMessage = GetAppConnectMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
            this.context.commit("SetValidateRequestTaxInvoiceReceiptLoadingStatus", LoadingStatusType.Fail);
          }
        } else {
          this.context.commit("SetValidateRequestTaxInvoiceReceiptLoadingStatus", LoadingStatusType.Fail);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetRequestTaxInvoiceContact(input: any) {
    if (this.contactForRequestTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetContactForRequestTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      API.CustomizeService.DoGetRequestTaxInvoiceContact(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          if (res.data.responseCode.IsSuccess()) {
            this.context.commit("SetRequestTaxInvoiceContactData", {
              contactData: res.data.data,
              contactInput: input.vailidateInput.contact,
              pickedContactOption: input.pickedContactOption,
            });
            this.context.commit("SetContactForRequestTaxInvoiceLoadingStatus", LoadingStatusType.Success);
          } else {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: "โปรดแจ้งเจ้าหน้าที่",
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
            this.context.commit("SetContactForRequestTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
          }
        } else {
          this.context.commit("SetContactForRequestTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoSubmitRequestTaxInvoice(input: any) {
    if (this.submitRequestTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetSubmitRequestTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      API.CustomizeService.DoSubmitRequestTaxInvoice(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          if (res.data.responseCode.IsSuccess()) {
            let responseData = {
              contact: input.contact,
              data: res.data.data,
            };
            this.context.commit("SetSubmitRequestTaxInvoiceData", responseData);
            this.context.commit("SetSubmitRequestTaxInvoiceLoadingStatus", LoadingStatusType.Success);
          } else {
            this.context.commit("SetSubmitRequestTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
          }
        } else {
          this.context.commit("SetSubmitRequestTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
}
